import { jsx as _jsx } from "react/jsx-runtime";
import wordmarkDarkUrl from "../assets/brand/instacheckin-wordmark-dark.png";
import wordmarkUrl from "../assets/brand/instacheckin-wordmark.png";
import { useTheme } from "../hooks/use-theme";
import { cn } from "../lib/cn";
import { DARK_NAV_PALETTES } from "../lib/palette";
/** Intrinsic size of both wordmark PNGs — set on the element so layout never shifts. */
const WORDMARK_WIDTH = 688;
const WORDMARK_HEIGHT = 96;
const SIZE_CLASSES = {
    /** Sidebar / drawer header. 28px tall ≈ 200px wide, inside the 16rem sidebar. */
    sm: "h-7",
    /** Above the auth card. */
    md: "h-10",
};
/**
 * The InstaCheckin wordmark. In dark mode the indigo "insta" would vanish into the
 * surface, so a variant with that half (and the indigo chevron) in near-white is swapped
 * in — the one legitimate use of `resolvedTheme` docs/010 names: an asset, not a colour.
 */
export function BrandLogo({ alt, size = "sm", className, onNav = false }) {
    const { resolvedTheme, palette } = useTheme();
    const isDark = resolvedTheme === "dark" || (onNav && DARK_NAV_PALETTES.includes(palette));
    return (_jsx("img", { src: isDark ? wordmarkDarkUrl : wordmarkUrl, alt: alt, width: WORDMARK_WIDTH, height: WORDMARK_HEIGHT, className: cn("block w-auto max-w-full select-none", SIZE_CLASSES[size], className), draggable: false }));
}
BrandLogo.displayName = "BrandLogo";
//# sourceMappingURL=brand-logo.js.map